import GtagNode from './node'
import GtagBrowser from './browser'

export default process.browser ? GtagBrowser : GtagNode
